var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiaphragm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.527 5.43286L27.4952 14.901L49.3307 30.7656C49.7676 28.9176 50 26.9915 50 25.0121C50 17.0893 46.2947 10.0165 40.527 5.43286Z",
    fill: "#23D997"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9867 3.65718C34.1994 1.34536 29.7525 0.0119629 25 0.0119629C19.8924 0.0119629 15.1385 1.55278 11.1763 4.19233L16.1563 19.5181L37.9867 3.65718Z",
    fill: "#23D997"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70518 6.06763C3.37842 10.6558 0 17.4465 0 25.012C0 27.3367 0.320117 29.5877 0.916504 31.7248H17.0424L8.70518 6.06763Z",
    fill: "#23D997"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93525 34.6545C5.58769 43.3584 14.0285 49.5738 23.9435 49.9881L28.9257 34.6545H1.93525Z",
    fill: "#23D997"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0434 49.928C36.8724 49.129 45.1109 42.6205 48.4298 33.7322L35.3851 24.2546L27.0434 49.928Z",
    fill: "#23D997"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaphragm);
export default __webpack_public_path__ + "static/media/diaphragm.db80149133415ef61454d3a71f2d5574.svg";
export { ForwardRef as ReactComponent };